// extracted by mini-css-extract-plugin
export default {"returnPolicy":"ReturnPolicy_returnPolicy__H9lmf"};